const PriceBreakdownFormatTypeEnum = {
  Json: 'json',
  EmailJson: 'email-json',
  Sharetribe: 'sharetribe',
};
module.exports = PriceBreakdownFormatTypeEnum;
